var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var EVENTS = {
  PRESS: 'press',
  PRESS_END: 'pressend',
  DOUBlE_CLICK: 'doubleclick',
  CLICK: 'click',
  TOUCH_MOVE: 'touchmove',
  TOUCH_START: 'touchstart',
  TOUCH_END: 'touchend'
};

var TOUCHS = {
  start: 'touchstart',
  end: 'touchend',
  move: 'touchmove',
  cancel: 'touchcancel'
};

var MOUSES = {
  start: 'mousedown',
  end: 'mouseup',
  move: 'mousemove',
  cancel: 'mouseleave'
};

function getTouch(touches) {
  if (touches && touches.length > 0) {
    return touches[touches.length - 1];
  } else {
    return null;
  }
}

function getDefaultConfig() {
  return {
    pressDelay: 600,
    dbClickDelay: 300,
    disablePress: false,
    disableDbClick: false,
    miniStep: 2
  };
}

var Touche = function () {
  function Touche(dom) {
    var _this = this;

    var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { eventType: 'touch' };

    _classCallCheck(this, Touche);

    this._pos = {
      moving: false,
      start: false,
      x: 0,
      y: 0
    };
    this.config = getDefaultConfig();
    Object.keys(config).map(function (key) {
      _this.config[key] = config[key];
    });
    this.root = dom;
    this.events = config.eventType === 'mouse' ? MOUSES : TOUCHS;
    this.pressIntrvalId = null;
    this.dbIntrvalId = null;
    this.__handlers = {};
    this._initEvent();
    this.timstamp = parseInt(window.performance.now(), 10);
  }

  _createClass(Touche, [{
    key: '_initEvent',
    value: function _initEvent() {
      this.onTouchStart = this.onTouchStart.bind(this);
      this.onTouchMove = this.onTouchMove.bind(this);
      this.onTouchEnd = this.onTouchEnd.bind(this);
      this.onTouchCancel = this.onTouchCancel.bind(this);
      // this.root.addEventListener('touchstart', this.onTouchStart)
      this.root.addEventListener(this.events.start, this.onTouchStart);
    }
  }, {
    key: '__stopPropagation',
    value: function __stopPropagation(e) {
      if (e) {
        e.stopPropagation();
        e.cancelable && e.preventDefault();
      }
    }
  }, {
    key: '__setPress',
    value: function __setPress(e) {
      var _this2 = this;

      var config = this.config;

      if (this.pressIntrvalId) {
        this.__clearPress();
      }
      this.pressIntrvalId = setTimeout(function () {
        _this2.trigger(EVENTS.PRESS, e);
        _this2._pos.press = true;
        _this2.__clearPress();
      }, config.pressDelay);
    }
  }, {
    key: '__clearPress',
    value: function __clearPress() {
      window.clearTimeout(this.pressIntrvalId);
      this.pressIntrvalId = null;
    }
  }, {
    key: '__setDb',
    value: function __setDb(e) {
      var _this3 = this;

      var config = this.config;

      if (this.dbIntrvalId) {
        // console.log('__clearDb0')
        this.__clearDb();
        this.trigger(EVENTS.DOUBlE_CLICK, e);
        return;
      }
      this.dbIntrvalId = setTimeout(function () {
        // console.log('__clearDb1')
        _this3.__clearDb();
        if (!_this3._pos.start && !_this3._pos.press && !_this3._pos.moving) {
          _this3.trigger(EVENTS.CLICK, e);
        }
      }, config.dbClickDelay);
    }
  }, {
    key: '__clearDb',
    value: function __clearDb() {
      // console.log('__clearDb', this.dbIntrvalId)
      clearTimeout(this.dbIntrvalId);
      this.dbIntrvalId = null;
    }
  }, {
    key: 'on',
    value: function on(event, handler) {
      if (!this.__handlers[event]) {
        this.__handlers[event] = [];
      }
      this.__handlers[event].push(handler);
    }
  }, {
    key: 'off',
    value: function off(event, handler) {
      if (!this.__handlers[event]) {
        return;
      }
      var handlers = this.__handlers[event];
      var index = -1;
      for (var i = 0; i < handlers.length; i++) {
        if (handlers[i] === handler) {
          index = i;
          break;
        }
      }
      if (index >= 0) {
        this.__handlers[event].splice(index, 1);
      }
    }
  }, {
    key: 'offAll',
    value: function offAll() {}
  }, {
    key: 'trigger',
    value: function trigger(event, e) {
      if (!this.__handlers[event]) {
        return;
      }
      this.__handlers[event].map(function (handler) {
        try {
          handler(e);
        } catch (error) {
          console.error('trigger>>:' + event, error);
        }
      });
    }
  }, {
    key: 'onTouchStart',
    value: function onTouchStart(e) {
      var time = parseInt(window.performance.now(), 10);
      console.log('onTouchStart', time - this.timstamp);
      this.timstamp = time;
      var _pos = this._pos,
          root = this.root;

      var touch = getTouch(e.touches);
      _pos.x = touch ? parseInt(touch.pageX, 10) : e.pageX;
      _pos.y = touch ? parseInt(touch.pageX, 10) : e.pageX;
      _pos.start = true;
      this.__setPress(e);
      // root.addEventListener('touchend', this.onTouchEnd)
      // root.addEventListener('touchcancel', this.onTouchCancel)
      // root.addEventListener('touchmove', this.onTouchMove)
      root.addEventListener(this.events.end, this.onTouchEnd);
      root.addEventListener(this.events.cancel, this.onTouchCancel);
      root.addEventListener(this.events.move, this.onTouchMove);
      this.trigger(EVENTS.TOUCH_START, e);
    }
  }, {
    key: 'onTouchCancel',
    value: function onTouchCancel(e) {
      var time = parseInt(window.performance.now(), 10);
      console.log('onTouchCancel', time - this.timstamp);
      this.timstamp = time;
      this.onTouchEnd(e);
    }
  }, {
    key: 'onTouchEnd',
    value: function onTouchEnd(e) {
      var _pos = this._pos,
          root = this.root;

      this.__clearPress();
      // root.removeEventListener('touchend', this.onTouchEnd)
      // root.removeEventListener('touchmove', this.onTouchMove)
      root.removeEventListener(this.events.cancel, this.onTouchCancel);
      root.removeEventListener(this.events.end, this.onTouchEnd);
      root.removeEventListener(this.events.move, this.onTouchMove);
      e.moving = _pos.moving;
      e.press = _pos.press;
      _pos.press && this.trigger(EVENTS.PRESS_END, e);
      this.trigger(EVENTS.TOUCH_END, e);
      // console.log('onTouchEnd', `press:${_pos.press} moving:${_pos.moving}`)
      var time = parseInt(window.performance.now(), 10);
      console.log('onTouchEnd', time - this.timstamp);
      this.timstamp = time;
      !_pos.press && !_pos.moving && this.__setDb() && console.log('__setDb');
      _pos.press = false;
      _pos.start = false;
      _pos.moving = false;
    }
  }, {
    key: 'onTouchMove',
    value: function onTouchMove(e) {
      console.log('onTouchMove');
      var _pos = this._pos,
          config = this.config;

      var touch = getTouch(e.touches);
      var x = touch ? parseInt(touch.pageX, 10) : e.pageX;
      var y = touch ? parseInt(touch.pageY, 10) : e.pageX;
      var diffx = x - _pos.x;
      var diffy = y - _pos.y;
      // console.log(`diffx: ${diffx} diffy:${diffy}`)
      if (Math.abs(diffy) < config.miniStep && Math.abs(diffx) < config.miniStep) {
        return;
      }
      this.__clearPress();
      _pos.press && this.trigger(EVENTS.PRESS_END, e);
      _pos.press = false;
      _pos.moving = true;
      this.trigger(EVENTS.TOUCH_MOVE, e);
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      var _this4 = this;

      var map = {
        touchend: 'onTouchEnd',
        touchmove: 'onTouchMove',
        touchstart: 'onTouchStart'
      };
      Object.keys(map).map(function (key) {
        _this4.root.removeEventListener('touchend', _this4[map[key]]);
      });
    }
  }]);

  return Touche;
}();

export default Touche;